import React from "react";
import { Image, Stack } from "react-bootstrap";
import { GoArrowRight } from "react-icons/go";
import './B2BAgents5.css';
import { useNavigate } from "react-router-dom";
import { handleContactRedirect } from "../../handleContactRedirect";

export const B2BAgents5 = () => {
  const navigate = useNavigate();

  const CardData = [
    { img: './assets/b2b5-img1.png', title: 'Luxury & Boutique Travel Brands' },
    { img: './assets/b2b5-img2.png', title: 'MICE & Group Travel Experts' },
    { img: './assets/b2b5-img3.png', title: 'FIT Travel Agents' },
    { img: './assets/b2b5-img4.png', title: 'Adventure & Experience Specialists' },
  ];

  const imageUrl = "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/b2b%20agent/b2b%20agent/Partner%20With%20Us.webp";

  return (
    <div className="agents5 standard-padding">
      <Stack className="agents5-container" style={{ backgroundColor: 'white' }}>
        <h1 className="heading mb-4 heading-mobile">Partner With Us & Grow Your Business</h1>
        
        <p className="text b2b5-text">
          Ready to collaborate with a DMC that understands the pulse of global travel businesses? 
          At BB, we empower our B2B partners with exclusive supplier access, negotiated wholesale rates, 
          and thoughtfully crafted itineraries that meet diverse market demands. Our on-ground expertise, 
          responsive support, and destination insight help your business deliver seamless travel 
          experiences with complete confidence. Let’s grow, achieve, and redefine success together.
        </p>

        {/* Image visible ONLY on Mobile */}
        <Image 
          src={imageUrl} 
          className="b2bAgents5-img-mobile" 
          alt="Partner with us"
        />

        <div className="mt-3">
          <p className="agents5-p">What We Offer:</p>
          <div className="agents5-card-div">
            {CardData.map((e, index) => (
              <div key={index} className="agents5-card">
                <Image src={e.img} alt={e.title} />
                <p className="agents5-card-title">{e.title}</p>
              </div>
            ))}
          </div>
        </div>

        <button 
          className="agents5-button mt-4 mt-md-2" 
          onClick={() => handleContactRedirect(navigate)}
        >
          Partner With Us <GoArrowRight className="left-arrow-icon" size={22} />
        </button>
      </Stack>

      {/* Image visible ONLY on Desktop */}
      <Image 
        src={imageUrl} 
        className="b2bAgents5-img" 
        alt="Partner with us"
      />
    </div>
  );
};